import { render, staticRenderFns } from "./sales-paper-detai.vue?vue&type=template&id=40d955d6&scoped=true"
import script from "./sales-paper-detai.vue?vue&type=script&lang=js"
export * from "./sales-paper-detai.vue?vue&type=script&lang=js"
import style0 from "./sales-paper-detai.vue?vue&type=style&index=0&id=40d955d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d955d6",
  null
  
)

export default component.exports